<app-icon-button
  class="bg-white disabled-gray"
  [size]="'small'"
  [type]="'secondary'"
  [svgIconPath]="'arrow-single'"
  [disabled]="isScrollDisabled"
></app-icon-button>
